<template>
  <div>
    <div
      class="rounded-md p-2 mt-2"
      :class="{ 'bg-green-50': validated, 'bg-yellow-50': !validated }"
    >
      <div class="flex">
        <div class="flex-shrink-0">
          <icon
            v-if="validated"
            set="solid"
            name="check-circle"
            class="flex-shrink-0 h-5 w-5 text-green-400"
          />
          <icon
            v-else
            set="solid"
            name="exclamation"
            class="flex-shrink-0 h-5 w-5 text-yellow-400"
          />
        </div>
        <div class="ml-2 flex-1 md:flex md:justify-between">
          <p
            class="text-sm leading-5"
            :class="{
              'text-green-700': validated,
              'text-yellow-700': !validated,
            }"
          >
            {{ message }}
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    validatedAddress: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {};
  },
  computed: {
    validated() {
      return this.validatedAddress?.validated;
    },
    message() {
      if (this.validated && this.validatedAddress?.correctedAddress) {
        return `Shipping Address updated and validated to '${this.validatedAddress?.correctedAddress}'`;
      }
      if (this.validated) {
        return "Shipping Address updated and validated.";
      }
      return "Shipping address was updated but not validated";
    },
  },
  components: {},
  methods: {},
};
</script>
